import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";

const ControllerCard = ({data}) => {
  const {
    name = "",
    serial = "",
    claimed_by = "",
    date_claimed = "",
    location = "",
  } = data;
  return (
    <CardBody>
      <CardTitle tag="h4">
        Name: <CardText>{name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Serial: <CardText>{serial}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Location: <CardText>{location}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Claimed By: <CardText>{claimed_by}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Claimed On: <CardText>{date_claimed}</CardText>{" "}
      </CardTitle>
    </CardBody>
  );
};

export default ControllerCard;
